import React, { useEffect, useState } from 'react';
import {
    InnerContainer,
    RequestBetContainer,
    RequestBetInput,
    SlideButton,
} from 'features/RequestBet/styled';
import Text from 'ui/Text';
import Button from 'ui/Button';
import UserService from 'utils/UserService';
import UISpinner from '../../ecoui/UISpinner';
import { detectMobile } from 'utils/UiHelper';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import { isTerminal } from '../../utils/UiHelper';
import infoIcon from 'images/icons/info_circle.svg';
import { RequestBetContentWrapper, RequestBetIconWrapper } from './styled';

const RequestBet = ({ event, user, uiActions }) => {
    const [isRequestSent, setIsRequestSent] = useState(false);
    const [isClosed, setIsClosed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [requestText, setRequestText] = useState('');
    const [requestAttempt, setRequestAttempt] = useState({});

    useEffect(() => {
        let containerState = window.localStorage.getItem('requestBetStatus');
        let attempts =
            JSON.parse(window.localStorage.getItem('requestAttempts')) || {};
        setRequestAttempt(attempts);
        if (containerState === 'closed') {
            setIsClosed(true);
        } else if (containerState === 'open') {
            setIsClosed(false);
        }
        if (!detectMobile()) {
            setIsClosed(false);
        }
    }, []);

    const calculateAttempts = () => {
        let attempts = {};
        if (requestAttempt[user.userId]) {
            attempts = {
                ...requestAttempt,
                [user.userId]: {
                    ...requestAttempt[user.userId],
                    [event.data.eventId]: requestAttempt[user.userId][
                        event.data.eventId
                    ]
                        ? requestAttempt[user.userId][event.data.eventId] + 1
                        : 1,
                },
            };
        } else {
            attempts = {
                ...requestAttempt,
                [user.userId]: {
                    [event.data.eventId]: 1,
                },
            };
        }
        setRequestAttempt(attempts);
        window.localStorage.setItem(
            'requestAttempts',
            JSON.stringify(attempts)
        );
    };

    const sendRequestBet = () => {
        if (!user?.userId) {
            detectMobile()
                ? uiActions.showModal('LOGIN_MOBILE')
                : !isTerminal()
                    ? uiActions.showModal('LOGIN', { stayOnPage: true })
                    : browserHistory.push('/sport/log-ind');
            uiActions.afterLoginSet(window.location.pathname);
        } else {
            setIsLoading(true);
            UserService.BetRequest(
                event.data.eventId,
                requestText,
                event.data.live ? 1 : 0
            )
                .then((res) => {
                    if (res.success) {
                        NotificationManager.success(
                            'Tak! Vi har sendt dit forslag videre'
                        );
                        calculateAttempts();
                        setRequestText('');
                        setIsRequestSent(true);
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };
    const toggleContainer = () => {
        window.localStorage.setItem(
            'requestBetStatus',
            isClosed ? 'open' : 'closed'
        );
        setIsClosed(!isClosed);
    };
    if (
        (event?.data?.eventId &&
            user?.userId &&
            requestAttempt[user.userId] &&
            requestAttempt[user.userId][event.data.eventId] >= 3) ||
        !event?.data?.eventId
    ) {
        return null;
    }
    return (
        <RequestBetContainer isClosed={isClosed}>
            <RequestBetIconWrapper>
                <img src={infoIcon} alt="" />
            </RequestBetIconWrapper>
            <RequestBetContentWrapper>
                {/*{detectMobile() ? (
                    <SlideButton isClosed={isClosed} onClick={toggleContainer}>
                        <i className="fa fa-caret-up" aria-hidden="true" />
                    </SlideButton>
                ) : null}*/}
                <InnerContainer column>
                    <Text color="#333333" size="12" bold padding="0 0 5px">
                        {isRequestSent && !isClosed
                            ? 'Tak! Vi har sendt dit forslag videre 🤞'
                            : 'Savner du et spil? Send dit forslag!'}
                    </Text>
                    {!isClosed ? (
                        <Text color="#333333" size="12" padding="5px 0">
                            {isRequestSent
                                ? 'Du vil modtage en bekræftelse til din Bet25 registrerede e-mail , hvis dit spil bliver valgt. Max. 3 forslag pr. konto.'
                                : 'Udvælges dit spil, bliver det synligt inden for få minutter under fanen her “Kundeønsker”.'}
                        </Text>
                    ) : null}
                </InnerContainer>
                {!isClosed ? (
                    <InnerContainer className={'right'}>
                        <RequestBetInput
                            placeholder="Skriv dit udfald her.."
                            value={requestText}
                            onChange={(e) => {
                                setRequestText(e.target.value);
                            }}
                        />
                        <Button
                            width="63px"
                            padding="10px 15px"
                            display="inline-block"
                            margin="0 0 0 7px "
                            onClick={sendRequestBet}
                            active={!!requestText}
                            disabled={!requestText}
                        >
                            {isLoading ? <UISpinner /> : 'Send'}
                        </Button>
                    </InnerContainer>
                ) : null}
            </RequestBetContentWrapper>
        </RequestBetContainer>
    );
};

export default RequestBet;
